"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _happy = _interopRequireDefault(require("./assets/happy.js"));

var _confused = _interopRequireDefault(require("./assets/confused.js"));

var _weary = _interopRequireDefault(require("./assets/weary.js"));

var TopicHelpfulness = function TopicHelpfulness(props) {
  return (0, _preact.h)("div", {
    className: "topic-helpfulness_container\n          ".concat(props.isVoted ? 'topic-helpfulness__voted' : '', "\n          ").concat(props.animationClass ? props.animationClass : '', "\n          ").concat(props.isSticky ? 'topic-helpfulness_float-bar' : 'topic-helpfulness_widget')
  }, !props.isVoted ? (0, _preact.h)("div", {
    className: 'topic-helpfulness'
  }, (0, _preact.h)("div", {
    className: 'topic-helpfulness_header'
  }, (0, _preact.h)("div", {
    className: 'topic-helpfulness-text'
  }, (0, _preact.h)("span", null, " ", props.phrases['topic.helpfulness.text'], " ")), props.showIndicator ? (0, _preact.h)("span", {
    className: "text--meta qa-topic-helpful-impact"
  }, (0, _preact.h)("span", {
    className: "qa-topic-helpful-percentage",
    "data-score": props.indicatorPercentage
  }, props.indicatorPercentage, "%", ' '), (0, _preact.h)("span", null, " ", props.phrases['topic.helpfulness.indicator'], " ")) : null), (0, _preact.h)("span", {
    className: "topic-helpfulness_reactions"
  }, (0, _preact.h)("span", {
    onClick: function onClick() {
      return props.setData('topichelpful');
    },
    className: "topic-helpfulness_reaction qa-topic-helpful-icon"
  }, (0, _preact.h)(_happy.default, null)), (0, _preact.h)("span", {
    onClick: function onClick() {
      return props.setData('topicneutral');
    },
    className: "topic-helpfulness_reaction qa-topic-neutral-icon"
  }, (0, _preact.h)(_confused.default, null)), (0, _preact.h)("span", {
    onClick: function onClick() {
      return props.setData('topicnothelpful');
    },
    className: "topic-helpfulness_reaction qa-topic-nothelpful-icon"
  }, (0, _preact.h)(_weary.default, null))), props.isSticky ? (0, _preact.h)("span", {
    onClick: function onClick() {
      return props.hideWidget();
    },
    className: "topic-helpfulness_dismiss"
  }) : null) : (0, _preact.h)("span", null, " ", props.phrases['topic.helpfulness.thanks'], " "));
};

var _default = TopicHelpfulness;
exports.default = _default;